export default {
    apiKey: "AIzaSyCZGomMHheIREi1xJXtBn7k7U2D-7xtfoc",
    authDomain: "rbespacios-f1777.firebaseapp.com",
    projectId: "rbespacios-f1777",
    storageBucket: "rbespacios-f1777.appspot.com",
    messagingSenderId: "790369618449",
    appId: "1:790369618449:web:c24654f4906d9fcb793fb0",
    measurementId: "G-RXDGEW7X8V"
}